import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import ApiCaregiversManager from 'services/api/ApiCaregiversManager';
import { selectCurrentUser } from 'store/users/selectors';

export const caregiverMeQueryKey = ['caregivers', 'me'] as const;

/**
 * Fetches the current caregiver's RegisteredCaregiver profile.
 * Only runs when the current user is a caregiver; returns undefined otherwise.
 */
export function useCaregiverMe() {
  const currentUser = useSelector(selectCurrentUser);
  const isCaregiver = !!currentUser?.is_caregiver;

  return useQuery({
    queryKey: caregiverMeQueryKey,
    queryFn: () => ApiCaregiversManager.getCaregiverMe(),
    enabled: isCaregiver,
    staleTime: Infinity,
  });
}

/**
 * Returns true when the current user is a caregiver AND is marked as a
 * first-line responder. Returns false while the query is still loading.
 */
export function useIsFirstLineCaregiver(): boolean {
  const { data } = useCaregiverMe();
  return !!data?.is_first_line_of_responders;
}
